/* eslint max-classes-per-file: 0 */

import {
  File as Data,
  FileCollection as Collection,
} from '@/typings/api/File'
import { FilesApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class FilesTransformerParams extends TransformerParams {
  public getAll(payload: Record<string, unknown>, rawParams: Record<string, unknown>) {
    const result = super.getAll(payload, rawParams)
    const p = result.params as Record<string, Record<string, unknown>>

    const params = {
      ...p,

      owner: p.owner?.id as number,
      tags: (p.tags as unknown as string[])?.join(','),
    }

    return { ...result, params }
  }
}

export class FilesAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new FilesTransformerParams();
}
